import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { useSelector } from "react-redux";
import { contentCollectionFormDescriptionSelector, contentCollectionFormTitleSelector } from "../redux";
export const ContentCollectionSidebarHeader = (param)=>{
    let { className, ...restOfProps } = param;
    const title = useSelector(contentCollectionFormTitleSelector);
    const description = useSelector(contentCollectionFormDescriptionSelector);
    return /*#__PURE__*/ _jsxs("header", {
        className: tailwindMerge("flex flex-col gap-3", className),
        ...restOfProps,
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: "text-20 font-semibold text-grey-11",
                children: title
            }),
            description && /*#__PURE__*/ _jsx("p", {
                className: "text-14 text-grey-10",
                children: description
            })
        ]
    });
};
